import React from 'react';

const PremiumIconSvg = () => {
  return (
    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 14.0002C0 21.7199 6.28035 28.0002 14 28.0002C21.7197 28.0002 28 21.7199 28 14.0002C28 6.28059 21.7197 0.000244141 14 0.000244141C6.28035 0.000244141 0 6.28059 0 14.0002Z" fill="url(#linear-645768)"/>
      <path d="M15.7461 7L18.3711 11.6667H9.62109L12.2461 7H15.7461Z" fill="#191B25"/>
      <path d="M13.9961 22.75L9.62109 12.8333H18.3711L13.9961 22.75Z" fill="#191B25"/>
      <path d="M3.49609 12.8333L13.9961 22.75L7.87109 12.8333H3.49609Z" fill="#191B25"/>
      <path d="M6.99609 7H12.2461L7.87109 11.6667H3.49609L6.99609 7Z" fill="#191B25"/>
      <path d="M20.1211 11.6667H24.4961L20.9961 7H15.7461L20.1211 11.6667Z" fill="#191B25"/>
      <path d="M13.9961 22.75L20.1211 12.8333H24.4961L13.9961 22.75Z" fill="#191B25"/>
      <defs>
        <linearGradient id="linear-645768" x1="14" y1="28.0002" x2="14" y2="0.000244141" gradientUnits="userSpaceOnUse">
          <stop stopColor="#987542"/>
          <stop offset="1" stopColor="#D1C08C"/>
        </linearGradient>
      </defs>
    </svg>
  );
};

export default PremiumIconSvg;